module.exports = __webpack_public_path__ + "static/media/plus.bbc582a4.svg";